import { Typography, Box, Divider } from '@mui/material';
import CodeBlock from '../../CodeBlock';

function SubmissionOverview() {


  const geoLocationExample = `{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [102.0, 2.0],
          [103.0, 2.0],
          [103.0, 3.0],
          [102.0, 3.0],
          [102.0, 2.0]
        ]]
      },
      "properties": {
        "area_name": "Production Area 1",
        "country_code": "MY",
        "commodity_type": "COCOA"
      }
    }
  ]
}`;

  return (
    <Box sx={{ textAlign: 'left', maxWidth: '900px' }}>

      <Typography variant="subtitle1" gutterBottom color="text.secondary">
        EUDR SOAP Version 1.3 - REST API Implementation
      </Typography>

      <Typography variant="body1" paragraph sx={{ my: 3 }}>
        The Submission Service enables creation and management of Due Diligence Statements (DDS)
        in compliance with EUDR requirements. All submissions are handled through a unified endpoint
        with different submission types.
      </Typography>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Base Endpoint
      </Typography>

      <CodeBlock code="POST /api/eudr/dds" />

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Submission Types
      </Typography>
      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        1. Domestic Production
      </Typography>
      <Typography variant="body1" paragraph>
        Used for reporting local production operations. Requires detailed geolocation data
        of the production area in GeoJSON format.
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        Required fields:
      </Typography>
      <ul>
        <li>submission_type: "DOMESTIC"</li>
        <li>geo_location: GeoJSON object (base64 encoded)</li>
        <li>commodity_details</li>
      </ul>

      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        2. Import/Export Operations
      </Typography>
      <Typography variant="body1">
        For cross-border transactions requiring customs documentation and country of origin details.
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        Required fields:
      </Typography>
      <ul>
        <li>submission_type: "IMPORT"</li>
        <li>customs_references</li>
        <li>country_of_origin</li>
      </ul>

      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        3. Trade Operations
      </Typography>
      <Typography variant="body1">
        For trading activities referencing existing DDS statements.
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        Required fields:
      </Typography>
      <ul>
        <li>submission_type: "TRADE"</li>
        <li>referenced_dds_uuid</li>
        <li>trade_details</li>
      </ul>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
        GeoJSON Data Structure
      </Typography>

      <CodeBlock
        code={geoLocationExample}
      />

      <Typography variant="body1">
        GeoJSON Data should be base64 encoded, that means you need to convert the GeoJSON object to a string and then encode it to base64.
      </Typography>


      <CodeBlock code={`// Here is an example of how to convert the GeoJSON object to a string and then encode it to base64 in JavaScript:
function objectToBase64(obj) {
    const jsonString = JSON.stringify(obj);
    return Buffer.from(jsonString).toString('base64');
}

const geoJsonBase64 = objectToBase64({
    type: 'FeatureCollection',
    features: [{
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [15.2, 45.1] }
    }]
});
`} />
      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Authentication
      </Typography>
      <Typography variant="body1">
        All requests require an API key in the Authorization header:
      </Typography>
      <CodeBlock code="Authorization: Bearer your-api-key-here" />
    </Box>
  );
}

export default SubmissionOverview; 